// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.disablePage[data-v-71455adc] {\n  position: fixed;\n  width: 100%;\n  left:0;\n  right:0;\n  top:0;\n  bottom:0;\n  background-color: rgba(255,255,255,0.8);\n  z-index:9999;\n}\n.spinner[data-v-71455adc] {\n  z-index: 999;\n  display:block;\n  position:absolute;\n  left:48%;\n  top:40%;\n}\n", ""]);
// Exports
module.exports = exports;
